import React from 'react';
import { Section } from '../components/ui/Section';
import { MetricCounter } from '../components/MetricCounter';
import { TestimonialCard } from '../components/TestimonialCard';
export const Impact = () => {
  return <div className="pt-20" data-id="element-482">
      <div className="bg-[#0A2540] text-white py-20 md:py-32" data-id="element-483">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-484">
          <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-485">Our Impact</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-486">
            Measuring our success not just in numbers, but in the lives
            transformed and futures reimagined.
          </p>
        </div>
      </div>

      <Section data-id="element-487">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-12" data-id="element-488">
          <MetricCounter value={3000} label="Audience Reached" suffix="+" data-id="element-489" />
          <MetricCounter value={200} label="Teachers Trained" suffix="+" data-id="element-490" />
          <MetricCounter value={5} label="Countries" data-id="element-491" />
        </div>
      </Section>

      {/* Story */}
      <Section background="gray" data-id="element-492">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-493">
          <div className="relative" data-id="element-494">
            <img src="https://cdn.magicpatterns.com/uploads/erz1J4AcmpKLgW9dAf4tmK/WhatsApp_Image_2025-12-31_at_02.05.13.jpg" alt="Students learning AI" className="rounded-2xl shadow-xl w-full" data-id="element-495" />
          </div>
          <div data-id="element-496">
            <h2 className="text-3xl font-bold text-[#1C274C] mb-6" data-id="element-497">
              Case Study: Lagos High School
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-498">
              Before partnering with AI For Kids Africa, Lagos High School had
              no computer science curriculum. Within 6 months of our
              intervention:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-499">
              <li className="flex items-center text-gray-700" data-id="element-500">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3" data-id="element-501"></div>
                100% of teachers trained in digital literacy
              </li>
              <li className="flex items-center text-gray-700" data-id="element-502">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3" data-id="element-503"></div>
                Student-led technology initiatives launched
              </li>
              <li className="flex items-center text-gray-700" data-id="element-504">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3" data-id="element-505"></div>3
                student projects won national awards
              </li>
            </ul>
          </div>
        </div>
      </Section>

      <Section data-id="element-506">
        <div className="text-center mb-16" data-id="element-507">
          <h2 className="text-3xl font-bold text-[#0A2540] mb-4" data-id="element-508">
            What People Are Saying
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-509">
          <TestimonialCard quote="This program changed my life. I never thought I could understand technology, but now I want to be a data scientist." author="Emmanuel" role="Student, Grade 10" data-id="element-510" />
          <TestimonialCard quote="The support from AI For Kids Africa has been phenomenal. They didn't just drop off tablets; they built a culture of innovation." author="Mrs. Adebayo" role="School Administrator" data-id="element-511" />
        </div>
      </Section>
    </div>;
};